module.exports = __webpack_public_path__ + "media/ro.625aca9e.svg";